import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AddMoreDreamPoints = ({ show, onHide, onSave ,roomId}) => {
  const [imgSrc, setImgSrc] = useState('');
  const [text, setText] = useState('');

  
  const generateObjectId = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString(16); // 8 characters
    const randomHex = 'xxxxxxxxxxxxxxxx'.replace(/x/g, () =>
      Math.floor(Math.random() * 16).toString(16)
    ); // 16 characters
    return timestamp + randomHex;
  };

  const handleSave = () => {
    const data = {
      "imgSrc": "chess-clock.svg",
      "_id": generateObjectId(),
      "text":text,
    };
    onSave(data);
    setText("");
    onHide(); 
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className='txt-color'>Add Custom Goal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            {/* <Form.Label>Image Source (imgSrc)</Form.Label> */}
            <Form.Control
              type="text"
              placeholder="Enter image source URL"
              value={imgSrc}
              onChange={(e) => setImgSrc(e.target.value)}
              hidden
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Enter Goal Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Goal Description"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button variant="secondary" onClick={onHide}>
          Close
        </Button> */}
        <button className='lrgbutton text-white ' onClick={handleSave}>
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMoreDreamPoints;
